module.exports = {
  log: {
    info: () => {},
    error: () => {},
    warn: () => {}
  }
}
